import React from 'react';
import { bool, shape, string } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { inspirationalLayoutDataModel } from './dataModel';
import { InspirationalLayoutRenderer } from './InspirationalLayoutRenderer';

/**
 * Main job for this component is to fetch data. The useDataModel call will cause this component to rerender which is
 * why the rendering of the components is split into InspirationalLayoutRenderer so that they don't unnecessarily
 * rerender. Rerendering components can result in extra API calls and processing, we do not want that.
 */
export const InspirationalLayout = ({
  canonicalURL, customerType, pageId, storeId, pageTypeComponents, thdSEOBotDetection
}) => {

  const { data, loading, error } = useDataModel('inspirationalLayout', {
    variables: {
      slug: pageId,
      customerType,
    },
  });

  if (!data || loading || error) {
    return null;
  }

  return (
    <InspirationalLayoutRenderer
      canonicalURL={canonicalURL}
      data={data}
      pageId={pageId}
      customerType={customerType}
      storeId={storeId}
      pageTypeComponents={pageTypeComponents}
      thdSEOBotDetection={thdSEOBotDetection}
    />
  );
};

InspirationalLayout.displayName = 'InspirationalLayout';

InspirationalLayout.dataModel = inspirationalLayoutDataModel;

InspirationalLayout.propTypes = {
  canonicalURL: string,
  customerType: string.isRequired,
  pageTypeComponents: shape({}).isRequired,
  pageId: string.isRequired,
  storeId: string.isRequired,
  thdSEOBotDetection: bool
};

InspirationalLayout.defaultProps = {
  canonicalURL: null,
  thdSEOBotDetection: false
};
